import React from 'react'
import { useTranslation } from 'react-i18next'
import { Ublique } from '@ublique/platform'
import { stores, routes, modals } from 'utils/imports'
import { getTableActions } from 'config/Scenario/actions'
import { VERSION_COMPONENTS, VERSION_PLATFORM } from './_version'
import outputConfigComponents from './config/Output'
Ublique.initI18n()

const languagesMenuConfig = {
  'it-IT': { full: 'Italiano', short: 'IT' }
}

const scenarioAllowedStatusForCloning = [
  'CREATED',
  'DONE',
  'READY',
  'FREEZED',
  'CONSOLIDATED',
  'ERROR'
]

const versionMap = {
  platform: VERSION_PLATFORM,
  components: VERSION_COMPONENTS
}

const importServiceConfig = {
  product: process.env.IMPORT_PRODUCT,
  customer: process.env.IMPORT_CUSTOMER,
  host: window.location.origin
}

const App = () => {
  const { t, i18n } = useTranslation('Scenario')

  const scenarioActionsConfig = getTableActions(t, i18n)

  return (
    <Ublique
      store={stores}
      routes={routes}
      modals={modals}
      importServiceConfig={importServiceConfig}
      scenarioActionsConfig={scenarioActionsConfig}
      scenarioAllowedStatusForCloning={scenarioAllowedStatusForCloning}
      languagesMenuConfig={languagesMenuConfig}
      librariesVersion={versionMap}
      outputConfigComponents={outputConfigComponents}
      fallbackRedirectPath='/extraOutput/OccupazioneSpazi' //ScFeedback
    />
  )
}

export default App
